import { getScreeningEventStatsThisMonth } from "../../api/screeningEvent";
import { useEffect, useState } from "react";
import MiniCard from "../../components/MiniCardUI";
import InvoicePaid from "../../assets/invoice-paid.svg";
import InvoiceNotPaid from "../../assets/invoice-bill.svg";
import EmojiCalendar from "../../assets/calendar.svg";
import EmojiMoney from "../../assets/images/money.png";
type Stats = {
  totalEvents: number;
  factured: number;
  nonFactured: number;
  totalRevenue: number;
};

const Dashboard: React.FC = () =>{

	const [stats, setStats] = useState<Stats | null>(null);

  const getDynamicTitle = () => {
    const month = new Intl.DateTimeFormat('fr-FR', { month: 'long' }).format(new Date());
    const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
    return `Statistiques du mois de ${capitalizedMonth}`;
  };
  useEffect(() => {
    async function fetchStats() {
      try {
        const statResult = await getScreeningEventStatsThisMonth();
        setStats(statResult);
        //console.log("statResult", statResult);
      } catch (err) {
        console.error("Failed to fetch stats:", err);
      }
    }
    fetchStats();
  }, []);
  if (!stats) return <p className="text-gray-500 mt-4 mx-16">Chargement...</p>;

  const displayStats = [
    {
      name: "Total journées",
      score: stats.totalEvents,
      emoji: EmojiCalendar,
      direction: "col",
    },
    {
      name: "Facturées",
      score: stats.factured,
      emoji: InvoicePaid,
      direction: "col",
    },
    {
      name: "Non facturées",
      score: stats.nonFactured,
      emoji: InvoiceNotPaid,
      direction: "col",
    },
    {
      name: "Revenus",
      score: stats.totalRevenue,
      emoji: EmojiMoney,
      direction: "col",
    },
  ];
  return (
  <>
    <div className="mx-16 my-patients">
    <header className="flex justify-between items-center w-full flex-wrap">
      <div className="title-container">
        <h1 className="text-3xl font-extrabold text-slate-800 tracking-tight">
          {getDynamicTitle()}
        </h1>
      </div>
    </header>

    <div className="flex flex-wrap gap-4 mt-6">
      {displayStats.map(({ name, score, emoji, direction }) => (
        <MiniCard
          key={name}
          name={name}
          score={name === "Revenus" ? score.toString() + " €" : score.toString()}
          emoji={emoji}
          direction={direction}
        />
      ))}
    </div>

    <div className="flex justify-between items-center w-full mt-5 filtres">
        
    </div>
    </div>

  </>
)}

export default Dashboard 